import React from 'react';


import { Modal, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import * as _ from 'lodash';

type IOtherCommentEvaluationProps = {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    nameCriteria: string;
    isLoading: boolean;
};

export const OtherCommentEvaluationComponent = ({ isOpen, onClose, data, nameCriteria, isLoading }: IOtherCommentEvaluationProps) => {
    const columns = [
        {
            title: <span className='fw-bold'>Người ý kiến</span>,
            key: 'userName',
            width: 250,
            render: item => item?.performerName ? `${item?.evaluateLevelName} - ${item?.performerName}` : item?.evaluateLevelName
        },
        {
            title: <span className='fw-bold'>Ý kiến</span>,
            key: 'explain',
            width: 250,
            dataIndex: 'explain',
        },
    ]
    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'50vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>{nameCriteria}</Title>
            </div>
            <Table columns={columns} pagination={false} loading={isLoading} dataSource={
                data.map(feedback => ({
                    key: feedback.versionName,
                    evaluateLevelName: feedback.versionName,
                    children: _.flatMap(feedback.otherLevelPoints, item =>
                        item.performerPoints?.map(value => ({
                            key: value.performerName,
                            evaluateLevelName: item.evaluateLevelName,
                            performerName: value.performerName,
                            explain: value?.evaluatePoint?.explain
                        }))
                    )
                }))}


            />
        </Modal>
    );
};

export default OtherCommentEvaluationComponent;
